// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3gFiX","Success":"Button_Success__2Rka1","Danger":"Button_Danger__2ogZq","Info":"Button_Info__sfM4H","Img":"Button_Img__2kBHr"};